import { atom, useAtomValue, useSetAtom } from 'jotai';

export const voucherDetailShow = atom<boolean>(false);
export const useVoucherDetailShow = () => {
  return useAtomValue(voucherDetailShow);
};
export const useSetVoucherDetailShow = () => {
  return useSetAtom(voucherDetailShow);
};

export const voucherDetailData = atom<Conversation.Voucher.Vo | null>(null);
export const useVoucherDetailData = () => {
  return useAtomValue(voucherDetailData);
};
export const useSetVoucherDetailData = () => {
  return useSetAtom(voucherDetailData);
};
